import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BoxIcon } from 'lucide-react';
interface PathCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
  isRecommended?: boolean;
  variant?: 'primary' | 'secondary' | 'tertiary';
  subtext?: string;
  onClick: () => void;
  delay?: number;
}
export function PathCard({
  title,
  description,
  icon: Icon,
  isRecommended = false,
  variant = 'secondary',
  subtext,
  onClick,
  delay = 0
}: PathCardProps) {
  const isTertiary = variant === 'tertiary';
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay,
    duration: 0.5
  }} className={`h-full ${isTertiary ? 'md:col-span-3 md:max-w-md md:mx-auto' : ''}`} data-id="element-27">
      <motion.div onClick={onClick} whileHover={{
      scale: isTertiary ? 1.01 : 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`relative h-full cursor-pointer group transition-all duration-300 rounded-2xl overflow-visible
          ${isRecommended ? 'border-2 border-[#ffc978]/50 bg-[#1a1a3e] shadow-xl shadow-[#ffc978]/10' : isTertiary ? 'border border-[#2a2a5a]/50 bg-[#0f0f2d]/60 hover:border-[#2a2a5a]' : 'border-2 border-[#2a2a5a] bg-[#1a1a3e]/80 hover:border-[#3a3a6a]'}
          p-6
        `} data-id="element-28">
        {isRecommended && <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-[#ffc978] text-[#0f0f2d] text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider shadow-lg whitespace-nowrap z-10" data-id="element-29">
            Recommended
          </div>}

        <div className={`flex ${isTertiary ? 'flex-row items-center gap-4' : 'flex-col items-center text-center'} h-full`} data-id="element-30">
          <div className={`${isTertiary ? 'p-3' : 'mb-6 p-4'} rounded-2xl transition-colors
              ${isRecommended ? 'bg-[#ffc978]/10 text-[#ffc978]' : isTertiary ? 'bg-[#1a1a3e]/50 text-[#5a5a7a]' : 'bg-[#0f0f2d] text-[#8b8bab] group-hover:text-[#a8c5e0] group-hover:bg-[#a8c5e0]/10'}`} data-id="element-31">
            <Icon size={isTertiary ? 24 : 32} strokeWidth={1.5} data-id="element-32" />
          </div>

          <div className={isTertiary ? 'flex-1' : ''} data-id="element-33">
            <h3 className={`font-bold mb-2 transition-colors
              ${isRecommended ? 'text-white text-xl' : isTertiary ? 'text-[#8b8bab] text-base group-hover:text-white' : 'text-white text-xl group-hover:text-[#a8c5e0]'}`} data-id="element-34">
              {title}
            </h3>

            <p className={`leading-relaxed ${isTertiary ? 'text-sm text-[#5a5a7a]' : 'text-[#8b8bab] mb-4'}`} data-id="element-35">
              {description}
            </p>

            {subtext && !isTertiary && <p className="text-xs font-medium text-[#5a5a7a] uppercase tracking-widest mt-auto" data-id="element-36">
                {subtext}
              </p>}
          </div>

          {isRecommended && <div className="mt-4 flex items-center justify-center text-[#ffc978] text-sm font-medium" data-id="element-37">
              <CheckCircle2 size={16} className="mr-2" data-id="element-38" />
              Most Popular
            </div>}

          {isTertiary && <span className="text-xs text-[#5a5a7a] font-medium" data-id="element-39">Advanced</span>}
        </div>
      </motion.div>
    </motion.div>;
}